import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ContactForm from './ContactForm';
import HeroImage from '../assets/banner5.jpeg';
import ObjetivosImage from '../assets/objetivo1.png';

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <section id="inicio" className="relative min-h-screen bg-white overflow-hidden" role="banner" aria-label="Página principal">
      {/* Fixed Background Image */}
      <div className="relative w-full h-[500px] md:h-[600px] lg:h-[700px] overflow-hidden bg-gray-400 mt-0 pt-0">
        <img
          src={HeroImage}
          alt="Fundación HK"
          className="w-full h-full object-cover"
        />
        
        {/* Overlay with Title and Mission - Sin filtro nublado */}
        <div className="absolute inset-0 flex items-end z-10">
          <div className="text-left px-8 pb-12 max-w-4xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 drop-shadow-2xl" style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.8), 0 0 20px rgba(0,0,0,0.5)' }}>
              Fundación <span className="text-fhk-orange-500">HK</span>
            </h1>
            <div className="w-24 h-1 bg-fhk-orange-500 rounded-full mb-6 shadow-lg"></div>
            <p className="text-base md:text-lg lg:text-xl text-white leading-relaxed font-medium drop-shadow-2xl" style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.8), 0 0 15px rgba(0,0,0,0.5)' }}>
              Empoderar a niñas y jóvenes a través de formación STEM, liderazgo y habilidades laborales para alcanzar una igualdad de género, oportunidades laborales y comunidades más prósperas, apoyadas por alianzas sólidas.
            </p>
          </div>
        </div>
      </div>
      
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" style={{ top: '500px' }}>
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 25% 25%, #1d979d 2px, transparent 2px),
                           radial-gradient(circle at 75% 75%, #f35000 2px, transparent 2px)`,
          backgroundSize: '60px 60px'
        }}></div>
      </div>


      <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 pt-20">
        {/* Call to Action Buttons */}
        <div className="flex flex-wrap justify-center gap-4 px-4 mb-16">
          <Link
            to="/nuestros-programas"
            className="bg-white text-fhk-cyan-600 border-2 border-fhk-cyan-500 px-6 py-3 md:px-8 md:py-4 rounded-full font-semibold text-base md:text-lg hover:bg-fhk-cyan-50 transition-all duration-300 transform hover:scale-105 shadow-lg w-full sm:w-auto sm:min-w-[240px] text-center"
          >
            Conoce Nuestros Programas
          </Link>
        </div>
      </div>

      {/* ODS Section */}
      <div className="relative z-10 bg-fhk-cyan-600 py-14">
        <div className="max-w-6xl mx-auto px-4 text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-8">
            OBJETIVOS DESARROLLO SOSTENIBLES
          </h2>
          <div className="flex justify-center mb-8">
            <img 
              src={ObjetivosImage} 
              alt="Objetivos de Desarrollo Sostenible" 
              className="max-w-md md:max-w-lg lg:max-w-xl h-auto rounded-2xl shadow-2xl"
            />
          </div>
          <p className="text-xl leading-relaxed">
            Nuestras iniciativas contribuyen activamente a alcanzar los ODS establecidos por Naciones Unidas. Trabajando junto a actores públicos y privados para promover una educación inclusiva y de calidad, empoderar a mujeres y niñas, generar oportunidades laborales, disminuir las brechas sociales, contribuir al desarrollo social y fortalecer alianzas estratégicas que permitan un impacto real y duradero.
          </p>
        </div>
      </div>
      
      {/* Contact Form Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-2 sm:px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" onClick={handleCloseModal}></div>
            <div className="inline-block w-full max-w-6xl p-2 sm:p-4 my-4 sm:my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <div className="flex justify-between items-center p-6 border-b border-gray-200">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                    Únete a Fundación <span className="text-fhk-orange-500">HK</span>
                  </h2>
                  <p className="text-gray-600">
                    Forma parte de nuestra comunidad que empodera a niñas y jóvenes en STEM
                  </p>
                </div>
                <button
                  onClick={handleCloseModal}
                  className="text-gray-400 hover:text-gray-600 transition-colors duration-200 p-2"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="p-6">
              <ContactForm />
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Hero;
